var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_150_579)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_150_579",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_150_579",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_150_579",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD3klEQVR4nO2dSY9NURDHf4mhWwhb3S1B8AUMK4RIs9UWSEwxb0jakNaWduiVdOJrGBeED0CEtGFjg40h6IGV7qQ5cqQIL31fut0z1L2vfkltbt5Q5//uO0OdOnXBMAzDMAzDMAzDmDazgHXAEWAAuAE8B14Bo8CE2Khcey6vuSzvWSufYUzBEuAUcBv4CriS9gW4BfQCXbQ484D9wH3gewBxi2wSuAfsA9ppIRbInfYuorhF9gm4ACyixswB+oCRDAI3mvfhrPhUKzYCLxQI3GgvgW5qgO8TrwI/FIhaZN63QaCNirIMeKhASDdNewKspGJ0B5qmucTmp4VbqAg7gG8KRHP/aX4xtBvlHI88J3aJzLfhGErpkcVBbpFcQLF3oQzfr40rEMdF6Ea2oYRVFR343AwGyBW5RW6TaZGruT3OPc++mvhv3Ad0iJ2Ta6m+3y9qsrAp8Yrv3BQ+9Cf8ft/WDalFng08S9hIJ3dxI4sT+/AidSCqL3EDXRNfUvtxOmU8ebiFhR4WDaKTsl90CoV2EsuOHvZ8b0LzQbbionEgk8iuiU+5/NkTU2i/kWpC80uDO7FE7socNCoiZ9ApSirDqYyNck38yunTyRhC++QWE5p/NLgWWmSfYjVmQtN4o42FTj9bl/ludk18y+3XmpBCH1XQoCJy+3WIgAwoaFARuf26SEBuKmhQEa5OA2LqkKirkNBDIYV+E2hnRBshdmpeh3RoOPDOiDbKRCQ/h3SkzC/egX7K7NT4NAsVQneiny4tQpfpOvrRz3ktXUfZwbBf6Z3dKb6pGQxtekea6Z0tWEizYLElOGmW4EdK9GEukBWR26+DIYW2MCmFQq8OKbQF/kkT+EfOVlvXQbyB8Df+WLEJzT8anIg1ubd0A/6IPCkxkij4KgE26yBuAg1S9sGEJn5KWHum8g+uiU+1THLMlYTulAl9hgTMl9Bgqwo9nCoRHUnEblWhe0l8WOhp4gZ2Bt4ZqcRhod9VZVIef+sPvDMyU/NtXU8mBhM2dOKvnZoQOyMztStkpE2O77qa2yNgLplZIQfTXU1tDFiOEjZXvOqMKzDfNW1FGdtrWBhlJ0o5VpNSP5OSE66anop3I+MaS/w0K/3zpaID32YqxlLggQLx3DTtsYaSPmXm2YMVKJl5RcM8OQQblKSVNdqznMvqmIGo05lCrI32WaJw3qfaMl8a+TaDwB+lUPdCWoh2YC9wN/JCZ1I2Uve0Wun5qeiQA+zX5WkUZcUdlc86ETMloOrMkny2w8AlyQYakkeBjPz1eJARuTYkr7kkp1j9e+3xIIZhGIZhGIZhGEyTnz7HEa5EfStQAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.bd8b03fd314a8aab4ab15f44ff4fba6a.svg";
export { ForwardRef as ReactComponent };